import { LICENSE_TIER, LicenseTierType, LICENSE_FEATURE_CODE, CheckLicenseResultPayload, LicenseInfo } from '@/types/license'

const LICENSE_STORAGE_KEY = 'daisy_license_info'

const getStoredLicenseInfo = (): LicenseInfo | null => {
  try {
    const data = localStorage.getItem(LICENSE_STORAGE_KEY)
    if (!data) {
      return null
    }
    return JSON.parse(data) as LicenseInfo
  } catch (error) {
    console.error('[License] Failed to parse license info from localStorage:', error)
    return null
  }
}

export const determineLicenseTier = (payload: CheckLicenseResultPayload): LicenseTierType => {
  if (payload.allFailed) {
    return LICENSE_TIER.NO_LICENSE
  }

  const { passedFeatures } = payload

  if (passedFeatures.includes(LICENSE_FEATURE_CODE.OPS)) {
    return LICENSE_TIER.OPS
  }
  if (passedFeatures.includes(LICENSE_FEATURE_CODE.TEAMS)) {
    return LICENSE_TIER.TEAMS
  }
  if (passedFeatures.includes(LICENSE_FEATURE_CODE.PRO)) {
    return LICENSE_TIER.PRO
  }

  return LICENSE_TIER.NO_LICENSE
}

export const saveLicenseInfo = (payload: CheckLicenseResultPayload): void => {
  const tier = determineLicenseTier(payload)

  const licenseInfo: LicenseInfo = {
    tier,
    passedFeatures: payload.passedFeatures,
    conditionalFeatures: payload.conditionalResult?.passedConditionalFeatures,
  }

  localStorage.setItem(LICENSE_STORAGE_KEY, JSON.stringify(licenseInfo))
}

export const getLicenseInfo = (): LicenseTierType | null => getStoredLicenseInfo()?.tier ?? null

export const getLicenseFeaturesHeader = (): string => {
  const licenseInfo = getStoredLicenseInfo()
  if (!licenseInfo || !Array.isArray(licenseInfo.passedFeatures)) {
    return ''
  }

  const parts = [`passedFeatures=${licenseInfo.passedFeatures.join(',')}`]
  if (Array.isArray(licenseInfo.conditionalFeatures)) {
    parts.push(`conditionalFeatures=${licenseInfo.conditionalFeatures.join(',')}`)
  }

  return parts.join(';')
}

export const clearLicenseInfo = (): void => {
  localStorage.removeItem(LICENSE_STORAGE_KEY)
}

export const getConditionalFeatures = (): number[] => getStoredLicenseInfo()?.conditionalFeatures ?? []
